export default __webpack_public_path__ + "static/media/training-tour0.6a2d51d9.svg";